var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChannelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5827_126453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37253 0 0 5.37253 0 12C0 18.6274 5.37253 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37253 18.6273 0 12 0Z",
    fill: "url(#paint0_linear_5827_126453)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5827_126453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2353 6.70519H16.7647C16.9596 6.70519 17.1176 6.86321 17.1176 7.05813V10.5875C17.1176 10.7825 16.9596 10.9405 16.7647 10.9405H13.2353C13.0404 10.9405 12.8824 10.7825 12.8824 10.5875V7.05813C12.8824 6.86321 13.0404 6.70519 13.2353 6.70519ZM6.70588 13.5875H10.2353C10.4302 13.5875 10.5882 13.7456 10.5882 13.9405V17.4699C10.5882 17.6648 10.4302 17.8228 10.2353 17.8228H6.70588C6.51096 17.8228 6.35294 17.6648 6.35294 17.4699V13.9405C6.35294 13.7456 6.51096 13.5875 6.70588 13.5875ZM15.4813 13.0568L17.9519 17.2921C18.0892 17.5273 17.9195 17.8228 17.6471 17.8228H12.7059C12.4335 17.8228 12.2638 17.5273 12.401 17.2921L14.8716 13.0568C15.0078 12.8233 15.3451 12.8233 15.4813 13.0568ZM8.64706 6.17578C10.109 6.17578 11.2941 7.36091 11.2941 8.82284C11.2941 10.2848 10.109 11.4699 8.64706 11.4699C7.18513 11.4699 6 10.2848 6 8.82284C6 7.36091 7.18513 6.17578 8.64706 6.17578Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5827_126453",
    x1: -0.00000499327,
    y1: -20.2157,
    x2: 41.8109,
    y2: -6.88505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#7144FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B649F3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5827_126453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5827_126453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11.6471,
    fill: "white",
    transform: "translate(6 6.17578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelIcon);
export default __webpack_public_path__ + "static/media/channel_icon.70074ce44be4f318cf843240b963c880.svg";
export { ForwardRef as ReactComponent };